export const getLightbox = async () => {
  if (window.createLightbox) return window.createLightbox;
  try {
    window.createLightbox = (
      await import("../lightbox/constructor.js")
    ).createLightbox;
    return window.createLightbox;
  } catch (err) {
    console.error("Ошибка загрузки createLightbox:", err);
  }
};
